import { FormattedMessage as FM } from "react-intl";

const ProgressBar = ({ progress, maxValue }) => {
  const percentage = Math.min(
    100,
    Math.max(0, Math.round((progress / maxValue) * 100) || 0),
  );

  return (
    <div className="w-full">
      <div className="flex justify-between items-end mb-2">
        <span className="text-xs font-bold text-zinc-500 uppercase tracking-wider">
          <FM id="sale.sale.delivery.panel_progress" />
        </span>
        <span className="text-sm font-black text-zinc-900">
          {progress} / {maxValue} ({percentage}%)
        </span>
      </div>
      <div className="w-full h-3 bg-zinc-100 rounded-full overflow-hidden border border-zinc-200">
        <div
          className="h-full bg-amber-500 transition-all duration-500 ease-out shadow-[0_0_10px_rgba(245,158,11,0.3)]"
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar;
